import billingApi from "services/billingApi";
import catalogApi from "services/CatalogApi";
import checkoutApi from "services/checkoutApi";
import compositionApi from "services/compositionApi";
import dealerCareApi from "services/dealerCareApi";
import logisticsApi from "services/logisticsApi";
import ordersApi from "services/ordersApi";
import paymentApi from "services/paymentApi";
import reportApi from "services/reportApi";
import { setupInterceptors } from "services/interceptors";

const PROTECTED_APIS = [
  logisticsApi,
  ordersApi,
  dealerCareApi,
  catalogApi,
  reportApi,
  billingApi,
  compositionApi,
  paymentApi,
  checkoutApi,
];

export function configureAuthInterceptors(
  onRefreshToken: () => Promise<string | null>,
  onSignOut: () => void,
): () => void {
  const ejectInterceptors = PROTECTED_APIS.map((api) =>
    setupInterceptors(api, onRefreshToken, onSignOut),
  );

  return () => {
    ejectInterceptors.forEach((eject) => eject());
  };
}

export { PROTECTED_APIS };
